import { render, staticRenderFns } from "./ConfigurableSankeyV2.vue?vue&type=template&id=66010c8a&scoped=true&"
import script from "./ConfigurableSankeyV2.vue?vue&type=script&lang=js&"
export * from "./ConfigurableSankeyV2.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurableSankeyV2.vue?vue&type=style&index=0&id=66010c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66010c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66010c8a')) {
      api.createRecord('66010c8a', component.options)
    } else {
      api.reload('66010c8a', component.options)
    }
    module.hot.accept("./ConfigurableSankeyV2.vue?vue&type=template&id=66010c8a&scoped=true&", function () {
      api.rerender('66010c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/ConfigurableSankeyV2.vue"
export default component.exports